export class CreateModuloDto {}
